var map = {
	"./esm_ancient_game_metal_thin_strip_twist_sequence_4_squeak_crank_gear_open_slide_texture.wav": 156,
	"./smartsound_CINEMATIC_HIT_High_Metal_Click_01.wav": 157,
	"./smartsound_CINEMATIC_HIT_High_Metal_Click_02.wav": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;